import useMount from '@src/utils/hooks/use-mount';
import { observable } from 'mobx';
// import BaseModalStore from '@src/components/modal-container/base-modal-store';
import useUnmount from '@src/utils/hooks/use-unmount';

class ImageDetailModalStore {
  // 图片大图展示地址
  @observable imageDetailUrl = '';
  @observable imageDetailName = '';
  // 缩放比例

  onClickClose = () => {
    this.isOpen = false;
    this.isActive = false;
    this.imageDetailState = false;
    this.imageDetailUrl = '';
  };
  downloadImage() {
    const imageUrl = this.imageDetailUrl;
    const a = document.createElement('a');
    a.href = imageUrl;
    a.download = this.imageDetailName;
    // a.download = 'filename.jpg'; // 下载后的文件名
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  constructor(options = {}) {
    Object.assign(this, options);
  }
  use() {
    // super.use();
    useMount(() => { });
    useUnmount(() => {
      // alert('删除弹窗');
    });
  }
}

export default ImageDetailModalStore;
